import React, { useState, useEffect, useContext } from 'react';
import '../../css/rightarrow.css';
import rightarrow from '../img/rightarrow.jpg'
import { functionContext } from '../../App'


function Rightarrow(props) {

const { changeLevelRight } = useContext(functionContext);
// const levelNumber = Object.values(level)

// console.log("right arrow" + props.selectedLevel)

  return (
    <>
      <div id="right-arrow">
      <img src={rightarrow} alt="arrowbutton" id="right-arrow" onClick={() => changeLevelRight(props.selectedLevel)}></img>
      </div>
    </>
  )
}

export default Rightarrow;




